'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('../../components');

var _IndexFunds = require('./IndexFunds.css');

var _IndexFunds2 = _interopRequireDefault(_IndexFunds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndexFunds = (_dec = (0, _reactCssModules2.default)(_IndexFunds2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IndexFunds, _Component);

  function IndexFunds(props) {
    (0, _classCallCheck3.default)(this, IndexFunds);
    return (0, _possibleConstructorReturn3.default)(this, (IndexFunds.__proto__ || (0, _getPrototypeOf2.default)(IndexFunds)).call(this, props));
  }

  (0, _createClass3.default)(IndexFunds, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return IndexFunds;
}(_react.Component)) || _class);
exports.default = IndexFunds;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IndexFunds/IndexFunds.js
// module id = 1337
// module chunks = 0